export default "__VITE_ASSET__TuB6Et1___"